import type { DepopIntegration } from "src/interfaces/plaidIntegration.interface";
import type { SyncLock } from "../syncLock";
import {
  getExistingInventoryListingIds,
  listingIdsFromInventoryDownloadPayload,
  loadPendingInventoryListingIds,
  writeInventoryDownloadBatch,
} from "../inventoryDaily";
import { getDepopListingId } from "./resumeCutPoint";

/**
 * Listing ids from a daily inventory Storage payload (raw product rows, or
 * already-transformed rows with "Platform Listing Id").
 */
export function listingIdsFromDepopInventoryDownloadPayload(
  data: unknown
): string[] {
  return listingIdsFromInventoryDownloadPayload(data, getDepopListingId);
}

export function getExistingDepopInventoryListingIds(
  state: unknown
): Set<string> {
  return getExistingInventoryListingIds(state, "depop");
}

/**
 * Pending `depopInventory` Downloads with timestamp after the last inventory
 * sync cursor — progress from an aborted catch-up (cursor not advanced yet).
 */
export async function loadPendingDepopInventoryListingIds(args: {
  integrationId: string;
  lastSyncDate: Date;
  pendingInventoryEnabled?: boolean;
}): Promise<Set<string>> {
  return await loadPendingInventoryListingIds({
    ...args,
    downloadType: "depopInventory",
    listingIdsFromPayload: listingIdsFromDepopInventoryDownloadPayload,
    logLabel: "Depop",
    importPlatform: "depop",
  });
}

/** One Storage blob per list page; Downloads or pending upsert when flagged. */
export async function writeDepopInventoryDownloadBatch(args: {
  integration: DepopIntegration;
  items: unknown[];
  date: Date;
  timestamp: number;
  batchIndex: number;
  lock: SyncLock;
  pendingInventoryEnabled?: boolean;
}): Promise<void> {
  await writeInventoryDownloadBatch({
    integrationId: args.integration.id,
    items: args.items,
    date: args.date,
    timestamp: args.timestamp,
    batchIndex: args.batchIndex,
    lock: args.lock,
    storageFolder: "depopInventory",
    downloadType: "depopInventory",
    pendingInventoryEnabled: args.pendingInventoryEnabled,
  });
}
